import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { RegionalService } from 'src/app/services/portal-config/regional.service';

@Component({
	selector: 'app-regional-filter',
	template: `
		<app-select-filter 
			[disabled]="cUser.isDistributor() || disabled"
			[hasIcon] = "hasIcon"
			bindLabel = "name"
			bindValue = "id"
			placeholder = "Select {{label}}"
			[label] = "label"
			[multiple] = "multiple"
			[items] = "metadata.data"
			[(value)] = value
			(onChange)="changeFilter()"
			[clearable]="multiple"
		>
		</app-select-filter>
    `,
})

export class AppRegionalFilterComponent implements OnInit {
	@Input() disabled = false;
	@Input() value: any = null;
	@Output() valueChange = new EventEmitter();
	@Output() onFilter = new EventEmitter();
	@Input() hasIcon = false;
	@Input() hasAllOption = true;
	@Input() multiple = false;
	@Input() label = 'Regional';
	@Input() hasDefault = false;
	metadata = {
		data: [],
		limit: 100,
		total: 0,
		search: '',
	}
	constructor(private dataService: RegionalService, public cUser: CurrentUserService,) { }

	ngOnInit() {
		this.getData();
	}

	getData() {
		let mtd = this.metadata;
		/***** If current user is Distributor, set default value *****/
		if (this.cUser.isDistributor()) {
			if (this.multiple) this.value = [this.cUser.profile.regionGroup.id ];
			else this.value = this.cUser.profile.regionGroup.id;
			mtd.data = [
				{
					id: this.cUser.profile.regionGroup.id,
					name: this.cUser.profile.regionGroup.code,
				},
			];
			this.finish();
			/***** else, retrive normally from API *****/
		} else {
			if (!mtd.data.length || mtd.data.length < mtd.total) {
				const params = {
					limit: mtd.limit,
					offset: mtd.data.length,
					sortBy:'name|asc'
				}
				this.dataService
					.getRegionals(params)
					.subscribe((res: any) => {
						const mappedData = (res.data || []).map(d => {
							return {
								id: d.id,
								name: d.code,
							}
						})
						mtd.data = [...mtd.data, ...mappedData];
						mtd.total = res.metadata.total;

						if (mtd.data.length && mtd.data.length < mtd.total) this.getData();
						else {
							if (this.hasAllOption && !this.multiple) {
								mtd.data.unshift({
									id: '',
									name: 'All',
								});
							}

							if (this.multiple && this.hasDefault) {
								this.value = [mtd.data[0].id];
							}
							
							this.finish();
						}
					});
			}
		}
	}

	changeFilter() {
		this.valueChange.emit(this.value);
		this.onFilter.emit({ value: this.value, isFilter: true });
	}

	finish() {
		this.value = this.value ? this.value : this.metadata.data && this.metadata.data.length ? this.metadata.data[0].id : null;
		this.valueChange.emit(this.value);
		this.onFilter.emit({ value: this.value, isFilter: false });
	}

	refresh() {
		setTimeout(() => {
			this.value = null;
			this.metadata.data = [];
			this.getData();
		}, 500);
	}
}